import { createContext, useContext } from "react";

import { ImageSizes } from "@/utils/seo/imageSizes";

/**
 * Размеры картинок Strapi текущей страницы (имя файла → `[ширина, высота]`) для `<img>` из текста редактора.
 *
 * На сборке их кладёт в контекст страницы `gatsby-node`, `Layout` получает контекст от
 * `gatsby-plugin-layout` и раздаёт вниз. `null` — размеров нет, картинки выводятся как есть.
 */
export const ImageSizesContext = createContext<ImageSizes | null>(null);

export const useImageSizes = (): ImageSizes | null =>
  useContext(ImageSizesContext);
